import { Center } from '@euler/components/Center';
import { FC, memo, ReactNode } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { useOrderFormStyles } from '../components/styles';

export const IconWrapper: FC<{
  style?: StyleProp<ViewStyle>;
  children?: ReactNode;
}> = memo(({ style, children }) => {
  const styles = useOrderFormStyles();
  return <Center style={[styles.iconWrapper, style]}>{children}</Center>;
});
